import { render, staticRenderFns } from "./move-to-carryover-form.vue?vue&type=template&id=2265bfe8"
import script from "./move-to-carryover-form.vue?vue&type=script&lang=js"
export * from "./move-to-carryover-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports